import { useState } from 'react';
import { passwordFields } from "../../constants/formFields";
import Input from "./../Input";
import FormAction from "./../FormAction";

const fields=passwordFields;
let fieldsState = {};
fields.forEach(field=>fieldsState[field.id]='');

export default function Login(){
    const [passwordState,setPasswordState]=useState(fieldsState);

    const handleChange=(e)=>{
        setPasswordState({...passwordState,[e.target.id]:e.target.value})
    }

    const handleSubmit=(e)=>{
        e.preventDefault();
        passwordReset();
    }

    const passwordReset = () =>{

    }

    return(
        <form className="mt-8 space-y-6">
            <div className="-space-y-px">
                {
                    fields.map(field=>
                        <Input
                            key={field.id}
                            handleChange={handleChange}
                            value={passwordState[field.id]}
                            labelText={field.labelText}
                            labelFor={field.labelFor}
                            id={field.id}
                            name={field.name}
                            type={field.type}
                            isRequired={field.isRequired}
                            placeholder={field.placeholder}
                        />

                    )
                }
            </div>

            <FormAction handleSubmit={handleSubmit} text="Reset Password" />


        </form>
    )
}